import { useState } from 'react';
import style from './EpubEsignsContents.module.css';
import Pagination from '../../UI/Pagination/Pagination';
import tableStyle from '../../Style/TableModel.module.css';
import button from '../../Style/ButtonStyle.module.css';
import dateFormat from 'dateformat';
let PageSize = 8;


const EpubEsignsContents = (props) => {
    const [searchInputText, setSearchInputText] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    console.log("eSign are ",props);
    if(props.esigns==undefined || props.esigns.length==0){
        return null;
    }
    const searchTextArray = searchInputText.toLowerCase().trim().split(' ');
    const searchData = props.esigns.filter(esign => {
            return searchTextArray.every(i => esign.esign_subject_line.toLowerCase().indexOf(i) > -1)
        }
    );

    const esigns = searchData.slice(firstPageIndex, lastPageIndex);

    const searchHandler = (e) => {
        setSearchInputText(e.target.value);
        setCurrentPage(1);
    }

    return (
        <>
            <div className={tableStyle.buttonArea}>
                <div className="row">
                    <div className={"col-6 " + tableStyle.leftAlign}>
                        <h4 className={tableStyle.tableTitle}>eSigns</h4>
                        {/*<button type="button" className={"disabled " + button.modalBtn + ' ' + button.whiteButton}>All Esigns</button>*/}
                        {/*<button type="button" className={button.modalBtn + ' ' + button.whiteButton + ' ' + button.buttonSpaceLeft}>Newsletter Esigns</button>*/}
                        {/*<button type="button" className={button.modalBtn + ' ' + button.whiteButton + ' ' + button.buttonSpaceLeft}>Parent Surveys</button>*/}
                    </div>

                    <div className={"col-6 " + tableStyle.rightAlign + ' ' + tableStyle.modalSearch}>
                        <form method="post" onSubmit={(e) => e.preventDefault()}>
                            <div className={'form-group ' + tableStyle.hassearch}>
                                <i className={"icon icon-search2 " + tableStyle.searchIcon}></i>
                                <input
                                    value={searchInputText}
                                    onChange={searchHandler}
                                    type="search"
                                    className={tableStyle.searchInput}
                                    placeholder="Search..."
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">


                <table className={"table table-hover " + tableStyle.tableData}>
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Author</th>
                    <th scope="col">Status</th>
                    <th scope="col">Date Added</th>
                    {/*<th scope="col">Date Modified</th>*/}
                    {/*<th scope="col">Last Queued</th>*/}
                    {/*<th scope="col">Action</th>*/}
                </tr>
                </thead>
                <tbody>

                {esigns.map((esign) => {
                    return (<tr key={esign.esign_id}>
                        <td scope="row">
                            <div className={"form-check " + tableStyle.inputBtn}>
                                <input name="selectedId" onChange={props.onCheckedesign} className={"form-check-input " + tableStyle.radioBtn} type="radio" value={esign.permalink+'||'+esign.user_first_name+' '+esign.user_last_name+'||'+esign.esign_subject_line}  />
                            </div>
                        </td>
                        <td>{esign.esign_subject_line}</td>
                        <td>{esign.user_first_name} {esign.user_last_name}</td>
                        <td>{esign.esign_status}</td>
                        <td>{ dateFormat(esign.esign_add_date, "dd-mm-yyyy HH:mm:ss")}</td>
                        {/*<td></td>*/}
                        {/*<td></td>*/}
                        {/*<td></td>*/}

                    </tr>)
                })}
                </tbody>
            </table>
                </div>
            </div>
            <div style={{ float: 'right' }}>
                <Pagination
                    currentPage={currentPage}
                    totalCount={searchData.length}
                    pageSize={PageSize}
                    onPageChange={page => setCurrentPage(page)}
                />
            </div>
        </>
    );
}

export default EpubEsignsContents;
